import { MultiSelect } from '@/modules/shifts/ui/dialogs/multi-select.tsx'

import { useTrackingLinks } from '../hooks/useTrackingLinks'

interface Props {
  label?: string
  value: string[]
  excludeValues?: string[]
  onChange: (value: string[]) => void
}

export const TrackingLinksSelect = ({
  label,
  value,
  excludeValues,
  onChange,
}: Props) => {
  const { links, searchQuery, searchTrackingLinks, loadMoreTrackingLinks } =
    useTrackingLinks({ excludeValues })

  return (
    <div className="flex flex-col gap-2">
      <label
        htmlFor="TrackingIds"
        className="text-title text-sm font-medium"
      >
        {label}
      </label>
      <MultiSelect
        disableAllSelect
        value={value}
        searchValue={searchQuery}
        onChange={onChange}
        options={links}
        onSearch={searchTrackingLinks}
        loadMore={loadMoreTrackingLinks}
        entity="Tracking Links"
        placeholder="Tracking Link"
        searchPlaceholder="Search Tracking Links"
        className="w-full sm:max-w-[204px]"
      />
    </div>
  )
}
